import { render } from "./FormAlertsModalComponent.vue?vue&type=template&id=47df8e82"
import script from "./FormAlertsModalComponent.vue?vue&type=script&lang=js"
export * from "./FormAlertsModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__